module.exports = __webpack_public_path__ + "img/tibet.36936c3a.svg";